// extracted by mini-css-extract-plugin
export default {"root":"r6QQVE74za6gZzFXyFKg"};